"use strict";
import React from "react";
import ReactDOM from "react-dom";
import IgnoreEntryWrapper from "../ignore_entry_wrapper";
const DOCUMENT_BATCH_ID_ATTR = "document-batch-id";
const TAG = "ht-ignore-entry";
class IgnoreEntryElement extends HTMLElement {
  static get observedAttributes() {
    return [DOCUMENT_BATCH_ID_ATTR];
  }
  connectedCallback() {
    this.renderFromAttributes();
  }
  attributeChangedCallback(name) {
    if (name === DOCUMENT_BATCH_ID_ATTR) {
      this.renderFromAttributes();
    }
  }
  disconnectedCallback() {
    ReactDOM.unmountComponentAtNode(this);
  }
  renderFromAttributes() {
    const documentBatchId = this.getAttribute(DOCUMENT_BATCH_ID_ATTR);
    if (!documentBatchId) return;
    ReactDOM.render(
      React.createElement(IgnoreEntryWrapper, {
        documentBatchId: parseInt(documentBatchId, 10),
        onComplete: () => {
          this.dispatchEvent(
            new CustomEvent("ignore-complete", { bubbles: true })
          );
        },
        onCancel: () => {
          this.dispatchEvent(
            new CustomEvent("ignore-cancelled", { bubbles: true })
          );
        }
      }),
      this
    );
  }
}
if (!customElements.get(TAG)) {
  customElements.define(TAG, IgnoreEntryElement);
}
